import { cardRecoveryGuard } from './core/card-recovery.service';
import { RouterModule, Routes } from '@angular/router';

const staffAppRoutes: Routes = [
  { path: '', redirectTo: 'boarding', pathMatch: 'full' },
  {
    path: 'boarding',
    canActivate: [cardRecoveryGuard],
    loadChildren: () => import('./boarding/boarding.module').then((m) => m.BoardingModule),
  },
  {
    path: 'student',
    canActivateChild: [cardRecoveryGuard],
    children: [
      {
        path: 'r/donasub',
        loadChildren: () =>
          import('./student/scholarshipsubscription/student.scholarshipsubscription.module').then(
            (m) => m.StudentScholarshipSubscriptionsModule
          ),
      },
      {
        path: 'd',
        loadChildren: () =>
          import('./student/dashboard/student.dashboard.module').then((m) => m.StudentDashboardModule),
      },
      {
        path: 'r',
        loadChildren: () => import('./student/student.module').then((m) => m.StudentModule),
      },
      // Backward compatibility for pre-migration bookmarks (#/student/...).
      { path: 'donasub', pathMatch: 'full', redirectTo: 'r/donasub' },
      { path: 'schedule', pathMatch: 'full', redirectTo: 'r/schedule' },
      { path: 'billing', pathMatch: 'full', redirectTo: 'r/billing' },
      { path: 'review', pathMatch: 'full', redirectTo: 'r/review' },
      { path: 'helpcontact', pathMatch: 'full', redirectTo: 'r/helpcontact' },
      { path: 'addusersuccess', pathMatch: 'full', redirectTo: 'r/addusersuccess' },
      { path: 'verifyphone', pathMatch: 'full', redirectTo: 'r/verifyphone' },
      { path: '', pathMatch: 'full', redirectTo: 'r' },
    ],
  },
];

export const AppRouting = RouterModule.forRoot(staffAppRoutes, { useHash: true });
